import http from "../http-common";
import { TicketModel } from "@/models"

class TicketsService {
  sendTicket(ticket: TicketModel) {
    const body = ticket
    return http.post("/ticket", body);
  }
}

export default new TicketsService();
